import { call, put, race, take, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, CLEAR, fetchSuccess, fetchFailure } from '../../actions/datasources/uploadAuto';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Auto file import: detect + type + import in one shot, then poll the
// execution until it reaches a terminal state. The slice's response carries
// the same state object the component used to keep locally:
// { status: 'uploading'|'processing'|'completed'|'failed', progress, name,
//   format, detected, rows, error }
function* operation(action) {
  const { file } = action.payload;
  const name = file.name;
  yield put(fetchSuccess({ status: 'uploading', progress: 0, name }));
  let data;
  try {
    const form = new FormData();
    form.append('file', file);
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/upload`,
      form,
      { headers: { ...getLocalUser(), 'Content-Type': 'multipart/form-data' } },
    );
    data = res.data?.data || res.data;
    yield put(fetchSuccess({
      status: 'processing', progress: 5, name, format: data.file_format, detected: data.detected_schema,
    }));
  } catch (error) {
    yield put(ErrorAction(error));
    const msg = error.response?.data?.error || error.message;
    yield put(fetchSuccess({ status: 'failed', error: msg, name }));
    yield put(fetchFailure(msg));
    return;
  }

  const format = data.file_format;
  const detected = data.detected_schema;
  let attempts = 0;
  while (attempts < 150) {
    attempts += 1;
    try {
      const res = yield call(
        axios.get,
        `${config.API_URL}/ingestion/executions/${data.execution_id}`,
        { headers: getLocalUser() },
      );
      const ex = (res.data?.data || res.data)?.execution || (res.data?.data || res.data);
      const status = ex.status;
      const progress = ex.progress?.percentage ?? Math.min(90, 5 + attempts * 4);
      const rows = ex.stats?.rows_inserted ?? 0;
      if (status === 'completed') {
        yield put(fetchSuccess({ status: 'completed', progress: 100, name, format, detected, rows }));
        return;
      }
      if (status === 'failed' || status === 'cancelled') {
        yield put(fetchSuccess({ status: 'failed', name, format, error: ex.error?.message || 'Import failed.' }));
        return;
      }
      yield put(fetchSuccess({ status: 'processing', progress, name, format, detected, rows }));
    } catch (e) { /* keep polling */ }
    yield delay(2000);
  }
}

// CLEAR aborts an in-flight upload/poll (component reset or unmount).
function* run(action) {
  yield race([call(operation, action), take(CLEAR)]);
}

export function* watch() {
  yield takeLatest(REQUEST, run);
}
